<template>
  <div class="col-lg-12 text-center fixed-top">

    <div class="col-lg-12 text-center" style="z-index: 1050;">
      <img style="" class="col-lg-4 d-block ml-auto mr-auto  text-center"
           :src="findAttributeOnSiteInfo('loadingIcon')[0]"
           :alt="findAttributeOnSiteInfo('site_name')[0]">

      <b-row align-h="center" class="mt-5">
        <ul class="dots">
          <li></li>
          <li></li>
          <li></li>
        </ul>
      </b-row>

    </div>


  </div>
</template>

<script>
export default {
  name: "Loading"
}
</script>

<style scoped>
.dots li {
  background: var(--primary);
  border-radius: 100%;
  width: 18px;
  height: 18px;
  float: left;
  margin: 0 3px;
  animation: float 1.2s infinite;
  transform-origin: center;
  list-style-type:none;
}
.dots li:nth-child(2) {
  animation-delay: 0.2s;
}
.dots li:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes float {
  0%, 100% {
    transform: translateY(4px);
  }
  50% {
    transform: translateY(-4px);
  }
}
</style>